import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import AuthFetchForQF from "../general/AuthFetchForQF";
import CheckForInvalidLink from "../general/CheckForInvalidLink";
import GeneralAuthentication from "../general/GeneralAuthentication";
import QFMainPane from "../general/QFMainPane";
import { changeHelpOrTipText } from "../store/components";
import { storeProspectIdFromQF } from "../store/qf";
import {resetOperations } from "../store/operations"
const QuestionsFlow = () => {
  const { search } = useLocation();
  const dispatch = useDispatch();
  sessionStorage.clear();
  const prospectid = search.substring(4);

  let valid = false;
  if (prospectid && prospectid.length >= 24) valid = true;

  useEffect(() => {
    dispatch(storeProspectIdFromQF(prospectid));
    dispatch(changeHelpOrTipText(""));
    dispatch(resetOperations());
  }, [dispatch, prospectid]);

  return (
    <GeneralAuthentication>
      <CheckForInvalidLink valid={valid}>
        <AuthFetchForQF prospectid={prospectid}>
          <QFMainPane></QFMainPane>
        </AuthFetchForQF>
      </CheckForInvalidLink>
    </GeneralAuthentication>
  );
};

export default QuestionsFlow;
